import { createContext, useContext, useEffect, useState } from "react";
import { EN_CATEGORIES } from "@/data/productsEn";

/**
 * Mini-i18n ohne Abhaengigkeiten:
 * t("Deutscher Text", "English text") — Deutsch ist im Code und bleibt Standardsprache.
 * Die Wahl wird im localStorage gemerkt und in <html lang> uebertragen.
 */
const LangContext = createContext({ lang: "de", setLang: () => {}, t: (de) => de });

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        const saved = localStorage.getItem("mueller-lang");
        return saved === "en" ? "en" : "de";
    });

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    const setLang = (l) => {
        const next = l === "en" ? "en" : "de";
        setLangState(next);
        localStorage.setItem("mueller-lang", next);
    };

    const t = (de, en) => (lang === "en" && en != null ? en : de);

    return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);

/** Englische Produktnamen — EINE Quelle: abgeleitet aus EN_CATEGORIES (productsEn.js), kein Duplikat */
export const EN_CATEGORY_LABELS = Object.fromEntries(
    Object.entries(EN_CATEGORIES).map(([slug, c]) => [slug, c.label]),
);
